import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ScannedActionsSubject } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService, BackendFeatureService, BaseViewConfigService, FashionLoginComponent, LoginCheckService, LoginConfigService, NavbarConfigService } from 'gung-standard';
import { HlDisplayPortalFeaturesService, LanguageSettingsGroup, LoginSettingsGroup } from '../../services/hl-display-portal-features.service';
import { first, forkJoin, map } from 'rxjs';

@Component({
    selector: 'app-hl-fashion-login',
    templateUrl: './hl-fashion-login.component.html',
    styleUrl: './hl-fashion-login.component.css',
    standalone: false
})
export class HlFashionLoginComponent extends FashionLoginComponent implements OnInit {
  oauthLoginEnabled = false;
  showLanguageSelectionOnLogin = false;
  showRequestAccountTextInLogin = false;
  requestAccountEmail: string;

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    protected actions$: ScannedActionsSubject,
    protected location: Location,
    protected loginCheckService: LoginCheckService,
    protected loginConfigService: LoginConfigService,
    protected navbarConfigService: NavbarConfigService,
    protected baseViewConfigService: BaseViewConfigService,
    @Optional()
    protected oauth2Service: OAuthService,
    @Optional()
    @Inject('environment')
    protected environment: { [s: string]: any },
    protected hlDisplayPortalFeaturesService: HlDisplayPortalFeaturesService,
    protected backendFeatureService: BackendFeatureService
  ) {
    super(
      authService,
      formBuilder,
      route,
      router,
      actions$,
      location,
      loginCheckService,
      loginConfigService,
      navbarConfigService,
      baseViewConfigService,
      oauth2Service,
      environment,
      backendFeatureService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    forkJoin([
      this.hlDisplayPortalFeaturesService.getPublicPortalFeatureGroup('loginSettingsGroup')
      .pipe(
        first(),
        map(loginSettings => loginSettings as LoginSettingsGroup)
      ),
      this.hlDisplayPortalFeaturesService.getPublicPortalFeatureGroup('languageSettingsGroup')
      .pipe(
        first(),
        map(languageSettings => languageSettings as LanguageSettingsGroup)
      )
    ]).subscribe(([loginSettings, languageSettings]) => {
      this.oauthLoginEnabled = loginSettings.oauthLoginEnabled || this.oauthLoginEnabled;
      this.showLanguageSelectionOnLogin = languageSettings.showLanguageSelectionOnLogin || this.showLanguageSelectionOnLogin;
      this.requestAccountEmail = languageSettings.requestAccountEmail || this.requestAccountEmail;
      this.showRequestAccountTextInLogin = languageSettings.showRequestAccountTextInLogin || this.showRequestAccountTextInLogin;
    })

  }

  loginOauth() {
    if(!this.oauthLoginEnabled || !this.environment?.oauth2Enabled) {
      return;
    }
    // Initializes the login towards the oauth2 authentication provider.
    this.oauth2Service.initCodeFlow();
  }
}
